import { render, staticRenderFns } from "./batch_center.vue?vue&type=template&id=637f0b44&scoped=true&"
import script from "./batch_center.vue?vue&type=script&lang=js&"
export * from "./batch_center.vue?vue&type=script&lang=js&"
import style0 from "./batch_center.vue?vue&type=style&index=0&id=637f0b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f0b44",
  null
  
)

export default component.exports